import { Stack } from '@mui/material';
import InstaSpinner from 'components/InstaSpinner';

function InstaLoader() {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        // `position: fixed` + `inset: 0`, not a `height: 100vh`/`100dvh`
        // percentage/flex chain — this renders in two very different
        // places (the route-level Suspense fallback in App.tsx, nearly a
        // direct child of the `.App` div's own `height: 100vh`; and
        // BasicFeaturesUpsell's `isLoading` branch, nested many levels
        // deep under PrivateRoute's wrapper, which sizes itself with
        // `minHeight` rather than `height`). A `min-height` ancestor does
        // NOT establish a definite height for a descendant's percentage
        // `height` to resolve against — it stays `auto` — so a
        // `height: 100%` here would collapse to the spinner's own small
        // content size in that nested case, rendering it pinned to the
        // top of whatever tall-but-auto-height box it landed in, with
        // blank space below. `vh`/`dvh` sidesteps that specific gotcha
        // but depends on `vh` and `dvh` resolving to the same value as
        // each other and as every ancestor's own viewport-unit
        // calculation — not guaranteed across WebView versions/engines.
        // `position: fixed` has neither dependency: it sizes against the
        // viewport (or nearest transformed ancestor — nothing in this
        // tree applies one) directly, regardless of nesting depth or
        // which viewport unit any ancestor happens to use.
        position: 'fixed',
        inset: 0
      }}
    >
      <InstaSpinner />
    </Stack>
  );
}

export default InstaLoader;
